import { VueExtension } from '../../utils/extensions/vue'
import ChartLine from './chartline.jsx'
import './chartline.scss'

VueExtension.WithInstall(ChartLine)

export default ChartLine